/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import CountryCode from '@linc-technologies/linced-common/enums/country-code';
import config from 'linced-admin/config/environment';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class SchoolsRoute extends Route {
  // Services
  @service
  store;

  model() {
    let store = this.store;
    return hash({
      schools: store.findAll('school'),
      credentials: store.findAll('enrolments/credential'),
      optionSets: store.findAll('school-options/set'),
      peopleSchemaTemplates: store.findAll('people-schema/set'),
      // We only want the published page templates
      pageTemplates: store.query('posts/page', { isPublished: true }),
      // We only want the published goal subject templates
      goalSubjects: store.query('goals/subject', { isPublished: true }),
      milestoneSets: store.query('milestones/set', { isPublished: true }),
      autogroups: store.findAll('group'),
      enrolmentSchemaTemplates: store.findAll('enrolments/schema'),
      groups: store.findAll('schools/group'),
      sifZones: config.APP.sifEnabled
        ? hash({
            [CountryCode.AU]: store.findAll('sif/au/zone'),
          })
        : [],
      usageSets: store.findAll('schools/usage-set'),
    });
  }
}
